import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { ImageListItem, Paper, Typography } from "@mui/material";

//import { ReactComponent as Logo } from "../../vendor/1spoc-logo.svg";
import ResetPasswordComponent from "../../components/auth/ResetPassword";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleDomainData } from "../../redux/slices/whitelistsolutionSlice";

// const Brand = styled(Logo)`
//   fill: ${(props) => props.theme.palette.primary.main};
//   width: 250px;
//   height: 64px;
//   margin-bottom: 32px;
// `;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function ResetPassword() {
  const dispatch = useDispatch();
  const domainFetchSingleDataViaDomain = useSelector(
    (state) => state.whitelistsolution.domainFetchSingleDataViaDomain
  );

  const domainName = window.location.hostname;
  // console.log("\n\n Dashboard domainName  == " + domainName);

  React.useEffect(() => {
    dispatch(fetchSingleDomainData(domainName));
  }, [dispatch, domainName]);
  return (
    <React.Fragment>
      {/* <Brand /> */}

      {domainFetchSingleDataViaDomain?.data?.logo_url &&
        domainFetchSingleDataViaDomain?.data?.signIn_logo_url && (
          <ImageListItem>
            <img
              src={
                domainFetchSingleDataViaDomain?.data?.signIn_logo_url ??
                domainFetchSingleDataViaDomain?.data?.logo_url
              }
              alt="logo"
              loading="lazy"
              style={{
                maxWidth: "250px",
                // eslint-disable-next-line no-template-curly-in-string
                marginBottom: "32px",
              }}
            />
          </ImageListItem>
        )}
      <Wrapper>
        <Helmet title="Reset Password" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Reset Password
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Enter your email to reset your password
        </Typography>

        <ResetPasswordComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default ResetPassword;
